export const CREATE_CP_TEMPLATE = 'CREATE_CP_TEMPLATE'

export const UPDATE_CP_TEMPLATE = 'UPDATE_CP_TEMPLATE'
